import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

interface DraftCommentBoxProps {
	testId?: string;
}

const draftCommentStyle = xcss({
	width: '100%',
	height: '65px',
	backgroundColor: 'color.background.neutral',
	border: '1px solid',
	borderColor: 'color.border',
	borderRadius: 'border.radius.100',
	padding: 'space.100',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: 'color.text.disabled',
});

export const DraftCommentBox: React.FC<DraftCommentBoxProps> = ({
	testId = 'draft-comment-box',
}) => {
	return (
		<Box xcss={draftCommentStyle} testId={testId}>
			Add a comment...
		</Box>
	);
};
